import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';

export const OBJECT_SIDEBAR_CONTROL_METRIC = createPageSegmentLoadMetric({
	key: OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY,
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});
